import { Loader2 } from 'lucide-react';

/**
 * Full-screen loader shown while lazy route chunks are being fetched.
 * Matches the app's slate background so route transitions feel seamless.
 */
export function PageLoader() {
  return (
    <div className="flex h-full w-full min-h-[60vh] items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden="true" />
        <span className="text-xs font-medium tracking-wider text-muted-foreground uppercase">
          EXPAI · Cargando módulo…
        </span>
      </div>
    </div>
  );
}
